import {
  SUGGESTION_TAB_TITLE_MAX_DISPLAY_COUNT,
  SUGGESTION_TAB_TITLE_OVERFLOW_SUFFIX,
} from '../../utils/constants/suggestionTabAlerts';

export function buildSuggestionTabTitleParams(count: number, appName: string) {
  const displayCount =
    count > SUGGESTION_TAB_TITLE_MAX_DISPLAY_COUNT
      ? `${SUGGESTION_TAB_TITLE_MAX_DISPLAY_COUNT}${SUGGESTION_TAB_TITLE_OVERFLOW_SUFFIX}`
      : String(count);
  return { count, displayCount, appName };
}
